module.exports = __webpack_public_path__ + "media/images/icon-3-4a57f63a53f2cef3fdbacc7913aba290.png";